import { useState, useContext, useEffect } from 'react'

import debounce from 'garden/src/js/utils/debounce'

import { ERRORS } from '../services/constants'
import { Title } from '../common/Title'
import * as S from './styled'
import ErrorIcon from './ErrorIcon'
import SuccessIcon from './SuccessIcon'

const StatusIcon = ({ status }) => {
  if (status === 'success') {
    return <SuccessIcon width="19" height="19" />
  }

  return <ErrorIcon />
}

const formatPostalCode = postalCode => {
  return postalCode.replace(/\D/g, '').replace(/(\d{5})(\d{3})(.?)/, '$1-$2')
}

const PostalCode = ({ errors, zipCode, fetchPriceShipping }) => {
  const [statusZipCode, setStatusZipCode] = useState(null)
  const [postalCode, setPostalCode] = useState(zipCode)
  const fetchCart = debounce((postalCode) => {
    fetchPriceShipping(postalCode, true)
  }, 500)

  const onPostalCodeChange = event => {
    event.stopPropagation()

    const inputPostalCode = formatPostalCode(event.target.value)

    if (inputPostalCode.length > 8) {
      setStatusZipCode('success')
    } else {
      setPostalCode(inputPostalCode)
      setStatusZipCode('danger')
    }

    if (inputPostalCode.length > 8 && postalCode !== inputPostalCode) {
      setPostalCode(inputPostalCode)
      fetchCart(inputPostalCode)
    }
  }

  useEffect(() => {
    zipCode && setPostalCode(formatPostalCode(zipCode))
  }, [zipCode])

  useEffect(() => {
    if (errors && Object.keys(errors).find(error => {
      return [
        'invalid_cep',
        'invalid_address'
      ].includes(error)
    })) {
      setStatusZipCode('danger')
    }
  }, [errors])

  return (
    <S.PostalCodeWrapper>
      <S.Info>
        <Title>Cálculo do frete</Title>
        <S.PostalCodeSubtitle>
          Para finalizar sua compra, digite o número do seu CEP para calcular o frete do seu pedido.
        </S.PostalCodeSubtitle>
      </S.Info>
      <S.PostalCodeFieldset>
        <S.PostalCodeLabel>Digite seu CEP</S.PostalCodeLabel>
        <S.PostalCodeInput
          name="postal-code"
          placeholder="CEP"
          onChange={onPostalCodeChange}
          value={postalCode}
          statusZipCode={statusZipCode}
        />

        {statusZipCode && <StatusIcon status={statusZipCode} />}

        <S.PostalCodeLink
          href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
          className="color-primary"
          target="_blank"
        >
          Não sei meu CEP
        </S.PostalCodeLink>
      </S.PostalCodeFieldset>
    </S.PostalCodeWrapper>
  )
}

export default PostalCode
